import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15 11.25c-2.077 0-2.716-4.312-2.912-8.211-.04-.787-1.093-.998-1.426-.285C8.694 6.964 5.25 12.321 5.25 15A6.75 6.75 0 0012 21.75m0 0A6.75 6.75 0 0018.75 15c0-3.75-3.5-6.75-3.5-10.5M12 21.75a3.123 3.123 0 003.124-3.124c0-1.277-1.693-3.214-2.587-4.146a.736.736 0 00-1.074 0c-.894.932-2.587 2.869-2.587 4.146A3.123 3.123 0 0012 21.75z"
  })),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15 11.25c-2.077 0-2.716-4.312-2.912-8.211-.04-.787-1.093-.998-1.426-.285C8.694 6.964 5.25 12.321 5.25 15A6.75 6.75 0 0012 21.75m0 0A6.75 6.75 0 0018.75 15c0-3.75-3.5-6.75-3.5-10.5M12 21.75a3.123 3.123 0 003.124-3.124c0-1.277-1.693-3.214-2.587-4.146a.736.736 0 00-1.074 0c-.894.932-2.587 2.869-2.587 4.146A3.123 3.123 0 0012 21.75z"
  })),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M30 22.5c-4.154 0-5.432-8.624-5.824-16.422-.08-1.574-2.186-1.996-2.852-.57C17.388 13.928 10.5 24.642 10.5 30c0 7.456 6.044 13.5 13.5 13.5m0 0c7.456 0 13.5-6.044 13.5-13.5 0-7.5-7-13.5-7-21M24 43.5a6.246 6.246 0 006.248-6.248c0-2.554-3.386-6.428-5.174-8.292a1.473 1.473 0 00-2.148 0c-1.788 1.864-5.174 5.738-5.174 8.292A6.246 6.246 0 0024 43.5z"
  }))
};
export var Burn = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});